import { getNameInitials } from '../../common/nameInitials';
import { getInitials } from '../../common/getInitials';
import './Avatar.css';

const resolveInitials = ({ name, firstName, lastName, initials }) => {
    if (initials) return initials;
    if (name) return getNameInitials(name);
    return getInitials(firstName, lastName) || '?';
};

/**
 * Avatar circular con iniciales (tres tamaños: sm, md, lg).
 *
 * @param {'sm' | 'md' | 'lg'} [size]
 * @param {string} [name] Nombre completo para derivar iniciales.
 * @param {string} [firstName]
 * @param {string} [lastName]
 * @param {string} [initials] Iniciales explícitas (prioridad sobre nombre).
 * @param {'online' | 'offline'} [status] Indicador de conexión en la esquina del avatar.
 * @param {string} [statusLabel] Texto accesible para el indicador de conexión.
 */
export const Avatar = ({
    name,
    firstName,
    lastName,
    initials,
    size = 'md',
    status,
    statusLabel,
    className = '',
    ...props
}) => {
    const label = resolveInitials({ name, firstName, lastName, initials });
    const sizeClass = ['sm', 'md', 'lg'].includes(size) ? size : 'md';
    const statusText = statusLabel || (status === 'online' ? 'En línea' : status === 'offline' ? 'Desconectado' : '');

    const avatarNode = (
        <span
            className={`avatar avatar--${sizeClass}${className ? ` ${className}` : ''}`}
            aria-hidden={props['aria-label'] ? undefined : true}
            {...props}
        >
            <span className="avatar__text">{label}</span>
        </span>
    );

    if (!status) {
        return avatarNode;
    }

    return (
        <span className={`avatar-wrap avatar-wrap--${sizeClass}`}>
            {avatarNode}
            <span
                className={`avatar__status avatar__status--${status}`}
                title={statusText}
                aria-label={statusText}
            />
        </span>
    );
};
